import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PublicCarrier } from 'src/app/shared/models/public-carrier';
import { ROUTE_DRIVER_DASHBOARD } from 'src/app/shared/routes';
import { CarrierDataService } from 'src/app/shared/services/carrier-data.service';
import { CompanyInterestService } from 'src/app/registration/shared/company-interest.service';

@Component({
    selector: 'app-job-completed',
    templateUrl: './job-completed.component.html',
    styleUrls: ['./job-completed.component.scss'],
    standalone: false
})
export class JobCompletedComponent implements OnInit {
  carrierCompanyId: string = null;
  carrierName: string = null;
  carrierData: PublicCarrier = null;

  constructor(
    private readonly router: Router,
    private readonly carrierDataService: CarrierDataService,
    private readonly companyInterestService: CompanyInterestService
  ) { }

  ngOnInit(): void {
    this.carrierCompanyId = sessionStorage.getItem('carrierCompanyId');
    if (this.carrierCompanyId) {
      this.loadCarrierData(this.carrierCompanyId);
    }
  }

  loadCarrierData(companyId: string): void {
    this.carrierDataService.getCarrierPublicById(companyId).subscribe({
      next: (response) => {
        this.carrierData = response;
      },
      error: (err) => {
        console.error('Error fetching carrier data', err);
      }
    });
  }

  navigateBackToProfile(): void {
    this.companyInterestService.clearInviteApplySession();
    this.router.navigate([`/${ROUTE_DRIVER_DASHBOARD}`]);
  }
}
